<template>

	<div fluid class="main-frame fill-height">
	
		<!-- -------------------------------------------- -->
		<!--   Top Navigation Bar -->
		<!-- -------------------------------------------- -->

		<v-app-bar id="mainAppBar" ref="mainAppBar" class="mml-0 pp-0" style="padding-left: 0px; " app flat dark clipped-left clipped-right color="primary darken-1" :height="appBarHeight">
			
			<app-bar-tab-button :mroute="'/contenteditor/hof-bio-uni'" micon="mdi-file-document-edit" color="white">Content</app-bar-tab-button>
			<!--<app-bar-tab-button v-if="inProjectMode" :mroute="'/media/'+this.routeKey" micon="mdi-image-multiple" color="white">Media</app-bar-tab-button>-->
			<app-bar-tab-button :mroute="'/admin/users/active'" micon="mdi-account-multiple" color="white">Users</app-bar-tab-button>
			<app-bar-tab-button v-if="agile.loggedInUser.superAdmin" :mroute="'/viewseditor/'+this.routeKey" micon="mdi-page-next" color="white">Templates</app-bar-tab-button>

			
			<!-- Dev export button, only visible in electron -->
			<app-bar-tab-button
				v-if="inProjectMode && agile.loggedInUser.superAdmin && agileElectron.app"
				:mroute="'/devexport/'+this.routeKey"
				micon="mdi-cloud-download"
				color="white"
			>Data export</app-bar-tab-button>
			

			<!-- Logo -->
			<!--<img @click="$router.push('/')" v-if="!inProjectMode" alt="Logo" src="@/assets/ai_logo.svg" width="36" height="36" class="ml-3">
			<v-toolbar-title @click="$router.push('/')" v-if="!inProjectMode" color="white" class=" ml-1 pt-2">SHIFT</v-toolbar-title>-->

			<v-spacer/>

			<div class="subtitle-1 mr-4">Hofseth Biocare University</div>

			<!-- -------------------------------------------- -->
			<!--   User menu dropown -->
			<!-- -------------------------------------------- -->

			<!--<v-menu offset-y v-if="inProjectMode">
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" text small class="subtitle-1 mr-4">{{ agile.loggedInUser.currentProject.prettyName }}<v-icon class="pl-2">mdi-chevron-down</v-icon></v-btn>
				</template>

				<v-list dense>
					<v-list-item
						v-for="project in agile.loggedInUser.projects"
						:key="project.prettyName"
						router :to="'/contenteditor/'+project.key"
					>
						<v-list-item-content classs="ml-n4" >
							<v-list-item-title>{{ project.prettyName }}</v-list-item-title>
						</v-list-item-content>

					</v-list-item>
				</v-list>
			</v-menu>-->












			<!-- Test button -->
			<!--<v-btn icon @click="debugThis" >
				<v-icon color="white">mdi-android-debug-bridge</v-icon>
			</v-btn>-->


			<!-- Right menu navigation -->
			<v-avatar
				v-if="agile.loggedInUser.superAdmin"
				color="primary lighten-1"
				size="38"
				style="cursor: pointer;"
				@click.stop="drawerRight = !drawerRight"
				class="mr-2"
			>
				<v-icon color="white">mdi-menu</v-icon>
			</v-avatar>


			














			<router-link to="/" style="text-decoration:none">
				<v-avatar
					v-if="!agile.loggedInUser.superAdmin && !agile.loggedInUser.adminInSomeProject"
					color="primary lighten-1"
					size="38"
					style="cursor: pointer;"
					class="mr-2"
				>
					
						<v-icon color="white">mdi-home</v-icon>
					
				</v-avatar>
			</router-link>

			<!-- -------------------------------------------- -->
			<!--   User menu dropown -->
			<!-- -------------------------------------------- -->

			<v-menu offset-y>
				<template v-slot:activator="{ on }">
					<v-avatar color="primary lighten-1" v-on="on" size="38" style="cursor: pointer;">
						<!-- <span class="white--text headline" style="user-select: none; font-size: 17px !important">{{ agile.loggedInUser.avatarAbbrevation }}</span> -->
						<span class="white--text headline" style="user-select: none; font-size: 17px !important">{{ agile.loggedInUser.avatarAbbreviation }}</span>
					</v-avatar>
				</template>

				<v-list dense>
					<v-list-item
						v-for="item in userItems"
						:key="item.title"
						@click="signOut"
					>
						
						<v-list-item-icon>
							<v-icon>{{ item.icon }}</v-icon>
						</v-list-item-icon>

						<v-list-item-content class="ml-n4">
							<v-list-item-title>{{ item.title }}</v-list-item-title>
						</v-list-item-content>

					</v-list-item>
				</v-list>
			</v-menu>

		</v-app-bar>


		<!-- -------------------------------------------- -->
		<!--   Left Menu Drawer -->
		<!-- -------------------------------------------- -->

		<!-- <v-overlay
			absolute
			
			opacity="0.5"
			:value="drawerRight || drawerLeft"
			z-index="6"
		/> -->

		<!-- absolute
			temporary -->


		<v-navigation-drawer
			v-model="drawerLeft"
			absolute
			temporary
			clipped-left
			
			width="310"
			hide-overlay
		>
			
			<v-subheader class="subtitle-1 font-weight-bold mt-0 grey--text text--darken-3">Content management</v-subheader>

			<v-list class="pt-0">
				<v-list-item
					v-for="item in editorMenuItems"
					:key="item.title"
					router :to="item.route+'/'+routeKey"
					dense
				>
					<v-list-item-icon>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content class="ml-n4">
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<v-divider/>
			
			<v-subheader class="subtitle-1 font-weight-bold mt-0 grey--text text--darken-3">Developer</v-subheader>

			<v-list class="pt-0">
				<v-list-item
					v-for="item in devMenuItems"
					:key="item.title"
					router :to="item.route+'/'+routeKey"
					dense
				>
					<v-list-item-icon>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content class="ml-n4">
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<v-divider/>

			<v-list>
				<v-list-item
					v-for="item in extraMenuItems"
					:key="item.title"
					router :to="item.route"
					dense
				>
					<v-list-item-icon>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content class="ml-n4">
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-divider/>



		</v-navigation-drawer>


		<!-- -------------------------------------------- -->
		<!--   Right Menu Drawer -->
		<!-- -------------------------------------------- -->

		<v-navigation-drawer
			v-model="drawerRight"
			absolute
			temporary
			clipped-right
			right
			width="310"
			hide-overlay
		>
			
			<v-subheader class="subtitle-1 font-weight-bold mt-1 grey--text text--darken-3">Administration</v-subheader>
			<v-divider/>
			<v-list>
				<v-list-item
					v-for="item in adminMenuFiltered"
					:key="item.title"
					router :to="item.route"
					dense
				>
					<v-list-item-icon>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content class="ml-n4">
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			
			<v-divider/>
			<v-list>
				<v-list-item
					v-for="item in extraMenuItems"
					:key="item.title"
					router :to="item.route"
					dense
				>
					<v-list-item-icon>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content class="ml-n4">
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-divider/>


		</v-navigation-drawer>


		<!-- -------------------------------------------- -->
		<!--   Router view -->
		<!-- -------------------------------------------- -->

		<router-view :key="$route.fullPath"></router-view>

	</div>
</template>

<script>


// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import fb from '@/shift/fb';
import agile from '@/shift/agile';
import agileFb from '@/shift/agileFb';
import agileElectron from '@/shift/agileElectron';
import AppBarTabButton from '@/components/ui/AppBarTabButton'


export default
{

	name: 'MainFrame',
	components: { AppBarTabButton },


	data()
	{
		return {
			agileElectron: agileElectron,
			drawerLeft: null,
			drawerRight: null,

			inProjectMode: false,

			editorMenuItems: [
				{ title: 'Manage content', icon: 'mdi-file-document-edit', route: '/contentmanager' },
				{ title: 'Media library', icon: 'mdi-image-multiple', route: '/media' },
			],

			devMenuItems: [
				{ title: 'Create content types', icon: 'mdi-page-next', route: '/pagecreator' },
				{ title: 'Get code templates', icon: 'mdi-code-braces', route: '/codetemplates' },
				{ title: 'Setup content databases', icon: 'mdi-database', route: '/database' },
			],

			adminMenuItems: [
				{ title: 'Project management', icon: 'mdi-television-clean', route: '/admin/projects', access: 'superAdmin' },
				{ title: 'User management', icon: 'mdi-account-tie', route: '/admin/users/active', access: 'admin' },
				/* { title: 'Dashboard', icon: 'mdi-home-circle-outline', route: '/' }, */
			],

			extraMenuItems: [
				{ title: 'Dashboard', icon: 'mdi-home', route: '/', access: 'everyone' },
			],

			userItems: [
				/* { title: 'About', icon: 'mdi-logout-variant', route: '/contentmanager' }, */
				{ title: 'Log out', icon: 'mdi-logout-variant', route: '/login' },
			],
		}
	},

	computed:
    {
		adminMenuFiltered()
		{
			const filtered = [];

			for (let i = 0; i < this.adminMenuItems.length; i++)
			{
				const item = this.adminMenuItems[i];
				if ((item.access === 'superAdmin' && agile.loggedInUser.superAdmin) || (item.access === 'admin' && agile.loggedInUser.adminInSomeProject || agile.loggedInUser.superAdmin) || item.access === 'everyone')
				{
					filtered.push(this.adminMenuItems[i]);
				}
			}

			return filtered;
		},

		routeKey()
		{
			return this.$route.params.key;
		},

		// Get agile
		agile()
		{
			return agile;
		},

		appBarHeight()
		{
			return agile.appBarHeight();
		},

	},


	watch:
	{
		$route()
		{
			if (this.routeKey != '') agile.setCurrentProjectByKey(this.routeKey);
			this.inProjectMode = this.checkingProjectMode();
		}
	},


	created()
	{
		/* console.log("::", global);
		console.log("======================================================");
		console.log(app); */
	},


    

	methods:
	{

		// ----------------------------------
		//	FIREBASE:
		//	Check if we are authenticated!
		// ----------------------------------

		signOut()
		{
			//e.preventDefault();
			fb.auth.signOut();
			this.$router.push('/login');
		},


		// ----------------------------------
		//	Check to show editing buttons
		// ----------------------------------

		checkingProjectMode()
		{
			const inProject = (
				this.$router.currentRoute.name == 'ContentEditor' ||
				this.$router.currentRoute.name == 'MediaLibrary' ||
				this.$router.currentRoute.name == 'ViewsEditor' ||
				this.$router.currentRoute.name == 'DatabaseCreator' ||
				this.$router.currentRoute.name == 'CodeTemplates' ||
				this.$router.currentRoute.name == 'DevExport'
			);
			
			if (inProject) agile.loggedInUser.currentProject == agile.getProjectByKey(this.routeKey);

			return inProject
			
		},

		
		

		debugThis()
		{
			agileFb.updateSecurityRules();
			/*const makeSuperAdmin = fb.functions.httpsCallable('makeSuperAdmin');

			makeSuperAdmin('r0p1lgVkhDOChOOd5KMtkWqiRVr1')
			.then(result =>
			{
				console.log(result);

				// Refresh user list to show super admin card
				//this.getUserList();
			})
			.catch(er =>
			{
				console.log(er);
			});*/





			//global.ai.remote.app.quit();
			//window.ai.remote.quit();

			//this.$parent.$parent.destroy();
			//this.$parent.destroy();
			//this.$destroy();
			//5HNDPu8nFaYgclIrmYoA

			//dev-collection/dev-doc/abb-aqu-ipr/abb-aqu-ipr/page-types-sorting-folders

			//match /dev-collection/dev-doc/abb-aqu-ipr/{docId=**}

			/* const collection = fb.db
				.collection('dev-collection')
				.doc('dev-doc')
				.collection('abb-aqu-ipr')
				.doc('abb-aqu-ipr')
				.collection('page-types-sorting-folders');


			collection.doc('5HNDPu8nFaYgclIrmYoA').get()
				.then((doc) =>
				{
					console.log('Document', doc);
					console.log('Data', doc.data());
					console.log('Document', doc.id);
				})
				.catch((error) =>
				{
					console.log('Error getting document:', error.message);
				}); */



			//cbO84zgW0yHHlDzJtOZ2
			//BjDPbkJi94C4jUSYxRi9




			/* fb.db.collection("users").doc(agile.loggedInUser.uid).get()
			.then((doc) =>
			{
				console.log("Document", doc);
				console.log("Data", doc.data());
				console.log("Document", doc.id);
			})
			.catch((error) =>
			{
				console.log("Error getting document:", error.message);
			}); */
			

			//addAndDeploySecurityRule

			/* const addAndDeploySecurityRule = fb.functions.httpsCallable('addAndDeploySecurityRule');

			addAndDeploySecurityRule()
			.then(result =>
			{
				this.$root.ai_app.showProgressWheel = false;
				console.log("* Security?", result);
			})
			.catch(er =>
			{
				this.$root.ai_app.showProgressWheel = false;
				console.log("Error", er);
			}); */


		}
	},

	mounted()
	{
		//console.log(this.routeKey);
		this.inProjectMode = this.checkingProjectMode();
	},


}
</script>
